<template>
    <div id="app">
        <aktarimdialog ref="aktarimdialog"></aktarimdialog>


        <v-card flat>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" color="info">
                        <v-toolbar-title class="white--text">Bilet Aktarımları</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <a target="_self" v-bind:href="'#/bilet/yeni/id?'+'isl=yeni'">
                            <v-btn class="white--text" flat> Yeni
                                <v-icon right dark>add_circle_outline</v-icon>
                            </v-btn>
                        </a>

                    </v-toolbar>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm12>
                    <v-select hide-details="" :items="aktarimturu" clearable v-model="aktarimno" @change="dialogac(aktarimno)"
                        item-text="text" item-value="value" label="Aktarım Türünü Seçiniz..."></v-select>


                    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid"
                        lazy-validation>
                        <v-container fluid="">
                            <v-layout row wrap>

                                <v-flex xs12 sm12>
                                    <label for="userfile">Seçilen Dosya:</label>
                                    <input type="file" multiple name="file" id="file" ref="file" v-on:change="handleFileUpload()">
                                    <v-btn color="info" flat @click="SubmitFile()">açvçaç </v-btn>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>

                </v-flex>
                <v-card flat>
                    <v-flex xs12 md6>
                    </v-flex>
                    <!--
                                    <v-tooltip bottom>
                                        <v-btn large="" @click.native="dialogfiltre=true" :color="renk1" slot="activator">
                                            <v-icon dark>filter_list</v-icon>
                                        </v-btn>
                                        <span>Arama Filtresi Ekle</span>
                                    </v-tooltip>
                                         <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" v-model="date"
                                        v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihcomp>
                                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="date2"
                                        v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihcomp>

                                    <div v-if="load1">

                                    </div>-->

                    <v-btn large="" color="info" @click="klasorcreate()">
                        <v-icon>search</v-icon>
                    </v-btn>



                    <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="500px">
                        <v-card color="grey lighten-2">
                            <v-card-title>Filtre Seçimi</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-layout row="" wrap="">
                                    <div class="flex md12">
                                        <v-autocomplete clearable="" label="Cari Seçiniz" append-icon="search"
                                            autocomplete :loading="loading" v-model="caridegeri" :items="statecari"
                                            item-text="text" cache-items="" item-value="id" :search-input.sync="searchcari"></v-autocomplete>
                                    </div>
                                </v-layout>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
                <v-container fluid>
                    <v-layout row wrap>

                    </v-layout>
                </v-container>
            </v-layout>
        </v-card>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>


    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'


    import auth from '../../../api/auth'
    import tarihcomp from '../customcomp/tarihcomp'
    import aktarimdialog from "@/components/app/bilet/aktarimdialog.vue"


    export default {
        data() {
            return {
                aktarimno: null,
                search1: '',
                aktarimturu: [{
                        text: 'Amadeus Aktarımı',
                        value: '0'
                    },
                    {
                        text: 'THY İç Hat Aktarımı',
                        value: '1',
                    },
                    {
                        text: 'THY Kolay Bilet Rapor Entegrasyonu',
                        value: '2'
                    },
                    {
                        text: 'THY Kolay Bilet Sos Agent Entegrasyonu',
                        value: '3'
                    },
                    {
                        text: 'AtlasJet Aktarımı',
                        value: '4'
                    },
                    {
                        text: 'Galileo',
                        value: '5'
                    },
                    {
                        text: 'SABRE Aktarımı',
                        value: '6'
                    },
                    {
                        text: 'Pegasus Aktarımı',
                        value: '7'
                    },
                    {
                        text: 'SunExpress Aktarımı',
                        value: '8'
                    },
                    {
                        text: 'Onur Air Aktarımı',
                        value: '9'
                    },
                    {
                        text: 'İDO Aktarımı',
                        value: '10'
                    },
                    {
                        text: 'Turkuaz Aktarımı',
                        value: '11'
                    },
                    {
                        text: 'Sky Air Aktarımı',
                        value: '12'
                    },
                    {
                        text: 'WORLDSPAN Aktarımı',
                        value: '13'
                    },
                    {
                        text: 'Arkman Aktarımı',
                        value: '14'
                    },
                    {
                        text: 'Excel Dosyasından Bilet Aktarımı',
                        value: '15'
                    },
                    {
                        text: 'IATI Bilet Aktırımı',
                        value: '16'
                    },
                    {
                        text: 'Özel Excel Dosyadan Bilet Aktarımı',
                        value: '17'
                    },
                    {
                        text: 'MHY Aktarımı',
                        value: '18'
                    },
                    {
                        text: 'IATI Excel Dosyasından Bilet Aktarımı',
                        value: '19'
                    },
                    {
                        text: 'Arkman XML Aktarımı',
                        value: '20'
                    },
                    {
                        text: 'Borajet Bilet Aktarımı',
                        value: '21'
                    },
                    {
                        text: 'BiletBank Aktarımı',
                        value: '22'
                    },
                    {
                        text: 'BiletAll Aktarımı',
                        value: '23'
                    }
                ],
                caridegeri: null,
                dialogfiltre: false,
                loading: false,
                statecari: [],
                searchcari: '',
                renk1: 'info',
                date: null,
                menu: false,
                modal: false,
                dateFormatted: '',
                date2: null,
                menu2: false,
                dateFormatted2: '',
                modal2: false,
                harekettipi: '',
                items: [],
                itemsticket: [],

                StartDate: null,
                EndDate: null,
                load: false,
                load1: true,
                dialogmessage: '',
                dialog: false,
                progress: false,
                valid: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text1: '',
                file1: '',
                file: []

            }
        },
        methods: {
            handleFileUpload() {

                var uploadedFiles = this.$refs.file.files;
                for (var i = 0; i < uploadedFiles.length; i++) {
                    this.file.push(uploadedFiles[i]);
                }
            },
            SubmitFile() {

                var cred = JSON.parse(window.localStorage.getItem('credentials'));
                let formData = new FormData();
                for (var i = 0; i < this.file.length; i++) {
                    let file = this.file[i];
                    formData.append('file[' + i +']', file);
                }
                formData.append('CustomerCode', cred.AnaSirketKodu)
                formData.append('TransferType', '0')
                axios.defaults.baseURL = auth.API_URL;
                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                axios.post(auth.API_URL + 'api/TicketDefinitons/FileUpload',
                        formData, {
                            headers: {
                                Authorization: `Bearer ${auth.getAuthHeader()}`
                            }
                        }
                    ).then(function () {
                        console.log('tamam bu iş');
                    })
                    .catch(function () {
                        console.log('hata!!');
                    });
            },
            getDateNow: getDateNow,
            karsicariac: karsicariac,
            filtrekayit: filtrekayit,
            filtreiptal: filtreiptal,
            carigetir: carigetir,
            dialogac: dialogac,
            aktarimdeneme: aktarimdeneme,

            git: git
        },
        beforeMount: beforeMount,
        components: {
            aktarimdialog,
            'tarihcomp': tarihcomp
        },
        watch: {
            searchcari(val) {
                val && this.carigetir(val)
            }
        },
    }

    function dialogac(aa) {
        this.$refs.aktarimdialog.open(aa).then(sonuc => {
            if (sonuc == true) {
                console.log('dialog filtrelerini aldım')
            }

        });
    }



    function filtrekayit() {
        this.renk1 = 'orange darken-4'
        this.dialogfiltre = false
    }

    function filtreiptal() {
        this.renk1 = 'info'
        this.dialogfiltre = false
        this.caridegeri = null
        this.searchcari = null

    }

    function carigetir(v) {
        if (v.length >= 0) {
            this.loading = true
            setTimeout(() => {
                this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
                    q: escape(v)
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.statecari = response.body
                    this.Error = false
                }, (response) => {
                    if (response.status === 0) {
                        this.text = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
                this.loading = false
            }, 500)
        }
    }

    function karsicariac() {
        this.dialog = false
        var url1 = '#/carihareketler/duzenle/id?' + 'ac=' + this.CariHareket.Account + '&dt=' + this.CariHareket.Date +
            '&on=' + this.CariHareket.OrderNumber
        window.open(url1, '_target')
    }


    function git(v) {
        if (v.GenelBilgileri.Status == 'S' || v.GenelBilgileri.Status == 'Ia') {
            var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_target')
        } else if (v.GenelBilgileri.Status == 'V') {
            var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_target')
        }
    }

    function beforeMount() {

    }



    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }



    function aktarimdeneme() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        //  var file = new FormData($('#formaktarim')[0]);

        var form = document.getElementById('formaktarim');
        var formData = new FormData(form);

        console.log(formData)
        //         var Params= {
        //           CustomerCode :credentials.SirketAdi,
        // TransferType :'0'
        //         }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/FileUpload', file, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.itemsticket = response.body
            //this.items = response.body
            this.progress = false
            this.load1 = true
            this.load = false

        }, (response) => {
            if (response.status === 0) {
                this.error = 'Service Unavailable'
                this.load1 = true
                this.progress = false
                this.error = false
            } else {
                this.error = response.statusText
                this.load1 = true
                this.progress = false
                this.error = false

            }
        })


    }
</script>

<style>
</style>